import { useTranslation } from 'react-i18next'

import { File, Storefront, WebhooksLogo } from '@phosphor-icons/react'

import { CopyToClipBoard, Link, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const APICredentials = ({ info }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleM" tag="h3" customStyles={{ fontWeight: 600 }}>
        Reveni API
      </Text>
      <div>
        <CopyToClipBoard
          value={info?.selectedStore?.id}
          label={t('ID tienda')}
          fullWidth
          Icon={Storefront}
          helperText={t(
            'Este es el identificador interno de Reveni para tu tienda. Puede que te lo requiramos durante comunicaciones con nuestro equipo de soporte, o para la integración con terceros, junto con las Claves API.'
          )}
        />
        <CopyToClipBoard
          value={info?.selectedStore?.private_api_token}
          label={t('Clave API')}
          fullWidth
          Icon={WebhooksLogo}
          helperText={t(
            'Utiliza esta clave API para autenticar tu tienda con integraciones de terceros. Esta clave es única y permite acceso completo a las funcionalidades, por lo que debes protegerla y no exponerla o compartirla con terceros.'
          )}
        />
      </div>
      <Link href="https://reveni.readme.io/reference/introduction" target="_blank" rel="noreferrer">
        <File size={24} />
        {t('Ver documentación API')}
      </Link>
    </Styles.Container>
  )
}

export default APICredentials
